module.exports = __webpack_public_path__ + "static/media/12606826_1165506760137006_1843078350_n.1e81431f.jpg";